<template>
  <div class="grid-y grid-frame">
    <!--<div class="shrink vm--header">
      <div class="grid-x grid-padding-x bg-very-light-gray">
        <div class="cell auto">
          <h1>{{ forDate | date }}</h1>
        </div>
      </div>
    </div>-->
    <div class="cell auto " style="overflow-y: auto">
      <div class="vm--content">
        <l-map
          :zoom="zoom"
          :center="latlng"
          style="height: 350px">
          <l-tile-layer
            :url="url"
            :attribution="attribution"
          />
          <l-marker :lat-lng="latlng"></l-marker>
        </l-map>
      </div>
    </div>
    <div class="cell shrink modal-bottom-bar">
      <div class="buttons align-right bg-very-light-gray">
        <a href="" class="btn btn-white btn-small" @click.prevent="$modal.hide('modal-leaflet-map')">Close</a>
      </div>
    </div>
  </div>
</template>

<script>
//import L from 'leaflet'
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import { Icon } from 'leaflet'

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

export default {
  name: 'LeafletMap',
  components: {
    LMap,
    LTileLayer,
    LMarker
  },
  props: {
    title: {
      type: String,
      required: true
    },
    latlng: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      showMap: false,
      zoom: 12,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
    }
  }
}
</script>
